<template>
    <div id="produk-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'OSS Configs',
                    to: { path: '/landing-packages' },
                    exact: true,
                },
                {
                    text: 'Paket Landing Page',
                    to: { path: '/landing-packages' },
                    exact: true,
                },
                {
                    text: category.category_name,
                    to: { path: '/landing-packages/' + category.id },
                    exact: true,
                },
                { text: 'Ubah Paket' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Ubah Paket</h3>

        <v-card plain class="pa-4">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        ID *
                    </v-list-item-title>
                    <v-text-field v-model="data.id" outlined />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        ID Paket *
                    </v-list-item-title>
                    <v-text-field v-model="data.id_paket" outlined />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        ID Kelas *
                    </v-list-item-title>
                    <v-text-field v-model="id_kelas" outlined />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Deskripsi *
                    </v-list-item-title>
                    <v-text-field v-model="data.deskripsi" outlined />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Subscription Type *
                    </v-list-item-title>

                    <v-select
                        placeholder="Pilih Jenis"
                        v-model="data.type"
                        outlined
                        class="pa-0"
                        :items="[
                            { text: 'Tahunan', value: '1 TAHUN' },
                            { text: 'Bulanan', value: '1 BULAN' },
                        ]"
                    ></v-select>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pt-0 px-0 pb-6">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Fitur *
                    </v-list-item-title>
                    <v-text-field
                        class="pb-2"
                        hide-details
                        :disabled="queryId"
                        outlined
                        v-for="(fitur, i) in data.fitur"
                        :key="i"
                        v-model="data.fitur[i]"
                    >
                        <template v-slot:append-outer>
                            <v-btn
                                text
                                class="font-weight-bold dark--text py-3"
                                color="redLight"
                                v-if="
                                    i === data.fitur.length - 1 &&
                                    data.fitur.length != 1
                                "
                                @click="data.fitur.splice(i, 1)"
                            >
                                Hapus
                            </v-btn>
                        </template>
                    </v-text-field>
                    <v-container class="pa-0">
                        <v-btn
                            elevation="1"
                            :disabled="queryId"
                            @click="data.fitur.push('')"
                            block
                            class="font-weight-bold blew--text"
                            color="white"
                        >
                            <v-icon style="font-size: 16px !important"
                                >mdi-plus-circle</v-icon
                            >
                            Tambah Fitur
                        </v-btn>
                    </v-container>
                </v-list-item-content>
            </v-list-item>
            <v-list-item class="pa-0 mt-6">
                <v-row>
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Harga Normal
                                </v-list-item-title>
                                <v-text-field
                                    type="text"
                                    v-model="data.harga_normal"
                                    prefix="Rp"
                                    outlined
                                    separator=","
                                />
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Harga Asli *
                                </v-list-item-title>
                                <v-text-field
                                    type="text"
                                    v-model="data.harga_asli"
                                    prefix="Rp"
                                    outlined
                                    separator=","
                                />
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Potongan Referral
                    </v-list-item-title>
                    <v-text-field
                        type="number"
                        v-model="data.referral_discount"
                        prefix="Rp"
                        outlined
                        separator=","
                        :value="
                            data.referral_discount = Number(
                                data.referral_discount,
                            )
                        "
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Diskon
                    </v-list-item-title>
                    <v-text-field
                        type="number"
                        v-model="data.diskon"
                        prefix="%"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        URL
                    </v-list-item-title>
                    <v-text-field v-model="data.link" outlined />
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-card-actions class="py-2" v-if="data.type">
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    v-if="!$route.query.id"
                    @click="saveData()"
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import Spinner from "@/components/plugins/Spinner";

export default {
    name: "produk-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            type: {
                SUBSCRIPTION: "SUBSCRIPTION",
                TICKET: "TICKET",
            },
            title: this.$store.state.landingpackages.onEdit.deskripsi,
            queryId: null,
            selectedPicture: null,
            data: {},
            id_kelas: null,
            tryouts: [],
            category: null,
        };
    },

    mounted: function () {
        this.data = this.$store.state.landingpackages.onEdit;
        this.id_kelas = this.$store.state.landingpackages.editInfo.kelasId;
        this.category = this.$store.state.landingpackages.editInfo.category;
        if (!this.data) {
            this.$router.push("/landing-packages");
        }
    },

    destroyed() {},

    methods: {
        async saveData() {
            var context = this;
            var data = this.data;

            if (this.validateForm()) {
                context.isLoading = true;
                try {
                    var oldAss = this.$store.state.landingpackages.data;
                    const infos = this.$store.state.landingpackages.editInfo;
                    var raws = this.$store.state.landingpackages.raw;

                    var datatopush = oldAss.find(
                        (e) => e.id == infos.categoryId,
                    );
                    var datakelas = datatopush.list_data.find(
                        (e) => e.kelas == infos.kelasPaket,
                    );
                    var otherpaket = datakelas.pakets.filter(
                        (e) => e.id != infos.detailId,
                    );
                    var semuakelas = datatopush.list_data.filter(
                        (e) => e.kelas != infos.kelasPaket,
                    );
                    var newAss = oldAss.filter((e) => e.id != infos.categoryId);

                    otherpaket.push(this.data);
                    datakelas.pakets = otherpaket;
                    datakelas.id = this.id_kelas;
                    semuakelas.push(datakelas);
                    datatopush.list_data = _.orderBy(semuakelas, "id", "asc");
                    newAss.push(datatopush);

                    context.$store.commit("packages_edited", newAss);
                    raws.packages = newAss;
                    const parsed = JSON.stringify(raws);
                    const blob = new Blob([parsed], {
                        type: "application/json",
                    });

                    await this.$alioss.put(
                        "config/package_landing_page.json",
                        blob,
                    );
                    context.isLoading = false;
                    context.$store.commit("showAlert", {
                        message: `Berhasil Update Data!`,
                        type: "success",
                    });
                    context.saved = true;
                } catch (error) {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        submessage: error,
                        type: "error",
                    });
                    context.isLoading = false;
                }
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        editData: function () {
            var context = this;
            var id = this.queryId;
            var data = this.data;
            this.isLoading = true;
            data.package_grade = [this.data.package_grade];

            if (this.validateForm()) {
                SalesService.updatePaket(id, data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Berhasil disimpan!`,
                            type: "success",
                        });
                        context.$router.go(-1);
                    } else {
                        alert("Terjadi Kesalahan");
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        doUploadPicture: function (id) {
            var context = this;
            var picture = this.selectedPicture;
            var formData = new FormData();

            if (picture) {
                formData.append("name", picture.name);
                formData.append("file", picture);

                SalesService.uploadPaketPicture(
                    id,
                    formData,
                    function (result) {
                        if (result.success)
                            context.$router.push({ path: "/produk" });
                        else {
                            alert("Gagal Upload Picture : " + result.message);
                            context.isLoading = false;
                        }
                    },
                );
            } else {
                context.$router.push({ path: "/produk" });
            }
        },

        validateForm() {
            var err = false;
            if (!this.data.type) {
                this.$store.commit("showAlert", {
                    message: `Tipe produk wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else {
                if (!this.data.id) {
                    this.$store.commit("showAlert", {
                        message: `ID produk wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.deskripsi) {
                    this.$store.commit("showAlert", {
                        message: `Deskripsi wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (this.data.fitur.length < 1) {
                    this.$store.commit("showAlert", {
                        message: `Fitur wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.harga_asli) {
                    this.$store.commit("showAlert", {
                        message: `Harga Asli wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (this.data.harga_normal) {
                    const normalclean = this.data.harga_normal.replace(
                        "/,/g",
                        "",
                    );
                    const asliclean = this.data.harga_asli.replace("/,/g", "");
                    if (asliclean >= normalclean)
                        this.$store.commit("showAlert", {
                            message: `Harga Normal tidak boleh kurang dari atau sama dengan harga asli!`,
                        });
                    err = true;
                    this.errors.push(
                        "Harga Normal tidak boleh kurang dari atau sama dengan harga asli",
                    );
                }

                if (!this.data.id_paket) {
                    this.$store.commit("showAlert", {
                        message: `ID Paket wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                    this.errors.push("ID Paket wajib diisi");
                }
            }
            return !err;
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// Form.vue?5362ae2f